module.exports = __webpack_public_path__ + "img/iphone.d5923555.svg";